import { render, staticRenderFns } from "./ModalDetail.vue?vue&type=template&id=553d915c&"
import script from "./ModalDetail.vue?vue&type=script&lang=ts&"
export * from "./ModalDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports